var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrazilFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_1164)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 74,
    height: 74,
    rx: 37,
    fill: "#009B3A"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_44_1164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 15H78V65H4V15Z",
    fill: "#009B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9998 17.8216L70.5565 39.9561L40.9998 62.076L11.2988 39.9561L40.9998 17.8216Z",
    fill: "#FEDF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 51.7544C47.4052 51.7544 52.5977 46.4918 52.5977 40C52.5977 33.5082 47.4052 28.2456 41 28.2456C34.5948 28.2456 29.4023 33.5082 29.4023 40C29.4023 46.4918 34.5948 51.7544 41 51.7544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1438 39.2251C33.1387 39.2251 31.1913 39.5322 29.3594 40.1023C29.4459 46.5205 34.5956 51.6959 40.9426 51.6959C44.8662 51.6959 48.3426 49.7076 50.4342 46.6813C46.8424 42.1491 41.3177 39.2251 35.1438 39.2251ZM52.3095 42.193C52.4393 41.462 52.5258 40.7164 52.5258 39.9415C52.5258 33.4503 47.3329 28.1871 40.9282 28.1871C36.1535 28.1871 32.0568 31.1257 30.2681 35.2924C31.8405 34.9708 33.4561 34.7953 35.1149 34.7953C41.8658 34.8099 47.9531 37.6462 52.3095 42.193Z",
    fill: "#002776"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 74,
    height: 74,
    rx: 37,
    stroke: "white",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_1164"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 74,
    height: 74,
    rx: 37,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_44_1164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 50,
    fill: "white",
    transform: "translate(4 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazilFlag);
export default __webpack_public_path__ + "static/media/brazil-flag.de1a21491aa60abc18cab2f53726c904.svg";
export { ForwardRef as ReactComponent };